import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar/Navbar';
import { BrowserRouter as Router, Routes, Route, Navigate, useLocation } from "react-router-dom";
import Products from './components/Products/Products';
import './App.css';
import Swal from 'sweetalert2';
import ScrollProgress from './components/Scrollprogress/scrollprogress';
import AdminPage from './components/Admin/AdminPage';
import AuthHandler from './components/Auth/AuthHandler'; // Assuming you move AuthHandler to a separate component
import HomePage from './components/Home/HomePage'; 

function AppContent() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);
  const [userMessage, setUserMessage] = useState("");
  const [isUserLoggedIn, setIsUserLoggedIn] = useState(!!localStorage.getItem("userToken"));
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(!!localStorage.getItem("adminToken"));
  const location = useLocation();

  const handleLogout = (role) => {
    if (role === "user") {
      localStorage.removeItem("userToken");
      localStorage.removeItem("userId");
      setIsUserLoggedIn(false);
    } else if (role === "admin") {
      localStorage.removeItem("adminToken");
      localStorage.removeItem("adminId");
      setIsAdminLoggedIn(false);
    }
  };

  useEffect(() => {
    if (location.pathname.startsWith("/admin")) {
      handleLogout("user");
    } else {
      handleLogout("admin");
    }

    const handlePageRefresh = () => {
      if (isUserLoggedIn) {
        handleLogout("user");
      }
      if (isAdminLoggedIn) {
        handleLogout("admin");
      }
    };

    window.addEventListener("beforeunload", handlePageRefresh);

    return () => {
      window.removeEventListener("beforeunload", handlePageRefresh);
    };
  }, [location.pathname, isUserLoggedIn, isAdminLoggedIn]);

  const handleSendMessage = () => {
    if (!userMessage.trim()) {
      Swal.fire('Error', 'Please type a message before sending', 'error');
      return;
    }

    const phoneNumber = process.env.REACT_APP_WHATSAPPNO;
    if (!phoneNumber) {
      Swal.fire('Error', 'Whatsapp number is not configured', 'error');
      return;
    }

    const whatsappURL = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(userMessage)}`;
    window.open(whatsappURL, '_blank');

    setUserMessage("");
  };

  return (
    // <div>
    //   <Navbar isUserLoggedIn={isUserLoggedIn} isAdminLoggedIn={isAdminLoggedIn} handleLogout={handleLogout} isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
    //   {!isMenuOpen && <ScrollProgress />}
    //   <Routes>
    //     {location.pathname.startsWith("/admin") ? (
    //       !isAdminLoggedIn ? (
    //         <Route path="/admin/*" element={<AuthHandler setIsLoggedIn={setIsAdminLoggedIn} isAdmin={true} />} />
    //       ) : (
    //         <Route path="/admin/*" element={<AdminPage />} />
    //       )
    //     ) : (
    //       !isUserLoggedIn ? (
    //         <Route path="*" element={<AuthHandler setIsLoggedIn={setIsUserLoggedIn} isAdmin={false} />} />
    //       ) : (
    //         <>
    //           <Route path="/" element={<HomePage />} />
    //           <Route path="/stocklist-tanayajewel" element={<Products />} />
    //           <Route path="/" element={<Navigate to="/" />} />
    //         </>
    //       )
    //     )}
    //   </Routes>
    <div>
      <Navbar 
        isUserLoggedIn={isUserLoggedIn} 
        isAdminLoggedIn={isAdminLoggedIn} 
        handleLogout={handleLogout} 
        isMenuOpen={isMenuOpen} 
        setIsMenuOpen={setIsMenuOpen} 
      />
      {!isMenuOpen && <ScrollProgress />}
      <Routes>
        {location.pathname.startsWith("/admin") ? (
          !isAdminLoggedIn ? (
            <Route path="/admin/*" element={<AuthHandler setIsLoggedIn={setIsAdminLoggedIn} isAdmin={true} />} />
          ) : (
            <Route path="/admin/*" element={<AdminPage />} />
          )
        ) : (
          <>
            <Route path="/" element={<HomePage />} />
            <Route path="/auth" element={<AuthHandler setIsLoggedIn={setIsUserLoggedIn} isAdmin={false} />} />
            <Route 
              path="/stocklist-tanayajewel" 
              element={
                isUserLoggedIn ? (
                  <Products />
                ) : (
                  <Navigate to="/auth" replace />
                )
              } 
            />
            <Route path="*" element={<Navigate to="/" />} />
          </>
        )}
      </Routes>

      <div className="whatsapp-container">
        <div className="whatsapp-button" onClick={() => setIsChatOpen(!isChatOpen)}>
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
            alt="WhatsApp Icon"
            className="whatsapp-icon"
            loading="lazy"
          />
          <span className="whatsapp-text">Chat with us</span>
        </div>
        {isChatOpen && (
          <div className="chat-box">
            <div className="chat-header">
              Tanaya Jewel
              <button className="chat-close-btn" onClick={() => setIsChatOpen(false)}>
                ✖
              </button>
            </div>
            <div className="chat-body">
              <p className="chat-message">Welcome to Tanaya Jewel!</p>
            </div>
            <div className="chat-footer">
              <input
                type="text"
                className="chat-input"
                placeholder="Type your message..."
                value={userMessage}
                onChange={(e) => setUserMessage(e.target.value)}
              />
              <button onClick={handleSendMessage} className="chat-send-btn">
                Send
              </button>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function App() {
  return (
    <Router>
      <AppContent />
    </Router>
  );
}

export default App;